import React from 'react';
import {getTemplateUri} from "../../serverInfo";
import qs from 'query-string';
import {lastClickEl} from '../../const';
import cache from '../../cache';

export default class DesignCenterPreview extends React.Component {

    defaultHandleImage = `${getTemplateUri()}/dist/img/handle-unselected-v2.png`;
    defaultJawImage = `${getTemplateUri()}/dist/img/jaw-unselected-v2.png`;


    constructor(...arg) {
        super(...arg);
        this.resetState();
    }

    componentDidMount() {

    }

    setProductData = (product) => {
        const {type, ...productData} = product;
        if (product.type === 'handle') {
            this.setHandle(productData);
        } else if (type === 'jaw-insert' || type === 'jaw') {
            this.setJaw(productData);
        }
    };

    setHandle = (handle) => {
        this.setState({
            handle,
        });
    };

    setJaw = (jaw) => {
        this.setState({
            jaw,
        });
    };

    modularHandleClick = (event) => {
        event.preventDefault();
        cache.set(lastClickEl, event.currentTarget);
        Barba.Pjax.goTo(event.currentTarget.getAttribute('href'));
    };

    modularJawClick = (event) => {
        event.preventDefault();
        cache.set(lastClickEl, event.currentTarget); // Set this manually to trigger the fade transition
        Barba.Pjax.goTo(event.currentTarget.getAttribute('href')); // Have to do Pjax in React Component manually since React and Barba does not work well in IE
    };

    resetState() {
        this.state = {
            handle: {
                imgUrl: null,
                name: null,
                itemNo: null,
                slug: null,
                productID: null,
                size: null,
                length: null,
            },
            jaw: {
                imgUrl: null,
                name: null,
                itemNo: null,
                slug: null,
                productID: null,
                size: null,
                length: null,
            },
            cssClass: ``,
        };
    }

    setOptions(type, options) {
        let { [type]: typedata } = this.state;

        typedata = Object.assign(typedata, options);
        this.setState({
            [type]: typedata
        });
    }

    getSelectionQueryString() {
        let qsMap = {};
        if (this.state.handle.productID) {
            qsMap.selectedhandle = this.state.handle.productID;
        }

        if (this.state.jaw.productID) {
            qsMap.selectedjaw = this.state.jaw.productID;
        }

        return qs.stringify(qsMap);
    }

    show() {
        this.setState({
            cssClass: ``
        });
    }

    hide () {
        this.setState({
            cssClass: `design-center-preview__container--collapse`,
        });
    }

    render() {
        const inCompatibleCss = this.isInCompatible() ? 'design-center-preview--incompatible' : '';
        return [<div className={`design-center-preview__container ${this.state.cssClass}`} key={'design-center-preview'}>
            {DesignCenterPreview.renderDoubleCircleButton(
                <span
                    className="modular-label">MODULAR<br/>HANDLES</span>, 'modular-handle-btn', this.modularHandleClick, `?type=handle&${this.getSelectionQueryString()}`)}
            <div className={'design-center-preview__handle'}
                 style={this.state.handle.imgUrl && {backgroundImage: `url(${this.state.handle.imgUrl})`} || {}}>
            </div>

            {DesignCenterPreview.renderDoubleCircleButton(
                <span
                    className="modular-label">MODULAR<br/>JAW INSERTS</span>, 'modular-jaw-btn', this.modularJawClick, `?type=jaw-insert&${this.getSelectionQueryString()}`)}
            <div className={'design-center-preview__jaw'}
                 style={this.state.jaw.imgUrl && {backgroundImage: `url(${this.state.jaw.imgUrl})`} || {}}>
            </div>
        </div>,
            this.renderInfoTable(`${inCompatibleCss} d-none d-md-block`),
            this.renderInfoTable(`${inCompatibleCss} d-flex d-md-none`, 'info-table'),


        ];
    }

    isInCompatible() {
        return this.state.handle.size && this.state.jaw.size && this.state.handle.size !== this.state.jaw.size;
    }

    renderIncompatibleWarning() {
        return <span className="design-center-preview__incompatible-warning">The Handle and Jaw are incompatible.</span>
    }

    renderInfoTable(cssClass, key) {
        return <div className={`design-center-info-table__container ${cssClass}`} key={key}>
                {this.renderIncompatibleWarning()}

            <div className="workingLengthModal-modal-wrapper">
                <div className="modal fade" id="workingLengthModal" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header" style={{borderBottom: 'none'}}>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <img style={{width: '100%', height: 'auto'}} className="design-center-info-table__handle-icon"
                                     src={`${getTemplateUri()}/dist/img/working_length_def.png`}/>
                            </div>
                            <div className="modal-footer" style={{borderTop: 'none'}}>
                                <p>* Please note that the Working Length for modular lap instruments can only be measured after the modular insert has been installed into the modular handle.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



                <table>
                    <tbody>
                    <tr>
                        <th>
                            VIEWING
                        </th>
                        <th>
                            <div className="d-flex justify-content-between aligncenter">
                                <span>HANDLE</span>
                                <img className="design-center-info-table__handle-icon"
                                     src={`${getTemplateUri()}/dist/img/handle-icon.svg`}/>
                            </div>
                        </th>
                        <th>
                            <div className="d-flex justify-content-between aligncenter">
                                <span>JAW INSERT</span>
                                <img className="design-center-info-table__jaw-icon"
                                     src={`${getTemplateUri()}/dist/img/jaw-icon.svg`}/>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <td>
                            DIAMETER
                        </td>
                        <td>
                            <div className={'design-center-diameter__container'}>
                                <div
                                    className={`design-center-diameter__outer-circle ${DesignCenterPreview.is5mm(this.state.handle.size) ? 'design-center-diameter--active' : ''} `}>
                                    <div className={'design-center-diameter__inner-circle'}>
                                    </div>
                                </div>
                                <div className={'design-center-diameter__label'}> 5 mm</div>
                                <div
                                    className={`design-center-diameter__outer-circle ${DesignCenterPreview.is10mm(this.state.handle.size) ? 'design-center-diameter--active' : ''} `}>
                                    <div className={'design-center-diameter__inner-circle'}>
                                    </div>
                                </div>
                                <div className={'design-center-diameter__label'}>
                                    10 mm
                                </div>
                            </div>
                        </td>
                        <td>
                            <div className={'design-center-diameter__container'}>
                                <div
                                    className={`design-center-diameter__outer-circle ${DesignCenterPreview.is5mm(this.state.jaw.size) ? 'design-center-diameter--active' : ''} `}>
                                    <div className={'design-center-diameter__inner-circle'}>
                                    </div>
                                </div>
                                <div className={'design-center-diameter__label'}> 5 mm</div>
                                <div
                                    className={`design-center-diameter__outer-circle ${DesignCenterPreview.is10mm(this.state.jaw.size) ? 'design-center-diameter--active' : ''} `}>
                                    <div className={'design-center-diameter__inner-circle'}>
                                    </div>
                                </div>
                                <div className={'design-center-diameter__label'}>
                                    10 mm
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>NAME</td>
                        <td className={`${this.state.handle.name ? '' : 'design-center-diameter--empty'}`}>{this.state.handle.name || '( Choose Your Handle )'}</td>
                        <td className={`${this.state.jaw.name ? '' : 'design-center-diameter--empty'}`}>{this.state.jaw.name || '( Choose Your Jaw Insert )'}</td>


                    </tr>
                    <tr>
                        <td> ITEM #
                        </td>
                        <td className={`${this.state.handle.itemNo ? '' : 'design-center-diameter--empty'}`}>{this.state.handle.itemNo || '( Choose Your Handle )'}</td>
                        <td className={`${this.state.jaw.itemNo ? '' : 'design-center-diameter--empty'}`}>{this.state.jaw.itemNo || '( Choose Your Jaw Insert )'}</td>
                    </tr>
                    <tr>
                        <td className="working-length-title"> <span style={{cursor: 'pointer'}}  data-backdrop="false" data-toggle="modal" data-target="#workingLengthModal"> WORKING LENGTH <i
                            className="far fa-question-circle"></i></span>
                        </td>
                        <td colSpan="2" >
                            {this.state.handle.length && this.state.jaw.length && (this.state.handle.length + this.state.jaw.length).toFixed(2) + ' cm'}
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>;


    }

    static is5mm(size) {
        return size === '5';
    }

    static is10mm(size) {
        return size === '10';
    }

    static renderDoubleCircleButton(label = '', className = '', clickEvent = () => null, url = '#', style) {
        return <a href={url} onClick={clickEvent} className={`circle-button__container ${className} no-barba`} style={style}>
            {label}
            <div className={`circle-button__outer`}>
                <div className={`circle-button__inner`}>
                </div>
            </div>
        </a>;
    }


}
